import { render, staticRenderFns } from "./Encounters.html?vue&type=template&id=059f66d4&external"
import script from "./Encounters.js?vue&type=script&lang=js&external"
export * from "./Encounters.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports